module.exports = __webpack_public_path__ + "img/zhekouquan_bg.23a5ba4d.png";